// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2xTq1","title":"Header_title__2PYIR","side":"Header_side__3E2yI"};